import React, { useState, useEffect, useMemo } from 'react';
import { Formik } from 'formik';
import { Modal, Button, Form, Typography, Row, Col, Card, Space, Checkbox } from 'antd';
import { useQuery } from '@apollo/client';
import RequestForm from './RequestForm.jsx';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { fetchEmployeeClientsThunk, submitRefreshPage } from '../../../Slices/orderSlice.jsx'
import { fetchEmployeesByRoute } from '../../../Slices/Employeeaccessslice.js';
import { getOptionsByPath } from '../../../utilsdata.js';
import { useDispatch } from 'react-redux';
import { AntdButton, InputField, SelectInput, SwitchField, TextareaField } from '../../../blueplanitUtils/InputField.jsx';
import { ADD_REQUEST, CLIENT_SERVICESASSIGNED, REQUEST_PRIORITY, CLIENT_INFO } from '../../../Dropdownmanager.jsx';
import { GET_SLOTS_BY_EMPLOYEE } from '../../../Queries/clientSlots.js';


const validationSchema = Yup.object({
    from: Yup.string()
        .email('Invalid email format')
        .required('From Email is required')
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,}$/,
            'Please enter a valid email address with one of the allowed domains (.com, .info, .net, .org, .co)'
        ),

    to: Yup.string()
        .email('Invalid email format')
        .required('To Email is required')
        .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,}$/,
            'Please enter a valid email address with one of the allowed domains (.com, .info, .net, .org, .co)'
        )
        .notOneOf([Yup.ref('from'), null], 'From and To emails cannot be the same'),

    subject: Yup.string().trim().required('Subject is required'),
    clientName: Yup.string().required('Client Name is required'),
    body: Yup.string().trim().required('Body is required'),
});

const AddRequest = (props) => {
    const { handleClose, requestSubmit, RequestInfo, popupStatus, submitStatus, setSetPopupStatus, handleDialogClose, isDisabled } = props;
    const dispatch = useDispatch();
    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);


    const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails)
    const clientsData = useSelector((state) => state?.orders?.getAllClients)

   
    const [employeeDetails, setEmployeeDetails] = useState({});

    const userid = loginUser.id;


    // Route-filtered employees for Assign To dropdown (only employees with /request route access)
    const routeFilteredEmployees = useSelector((state) => state.employeeAccess?.routeFilteredEmployees?.["/request"] || []);
    const employeeOptions = routeFilteredEmployees;

    // Slot-based access — replaces the old AssignedClientEmail gate.
    // If the logged-in employee is in any active slots with an email,
    // replace the free-form clientName + to inputs with a single
    // dropdown of accessible (client, email) pairs. Picking one
    // auto-fills both clientName and to.
    const { data: slotsData } = useQuery(GET_SLOTS_BY_EMPLOYEE, {
        variables: { employeeId: userid },
        fetchPolicy: 'cache-and-network',
        skip: !userid,
    });
    const accessibleEmails = useMemo(() => {
        const records = slotsData?.getSlotsByEmployee?.records || [];
        // Only slots that are active AND have an assignedEmail can be
        // submitted to. Slots without an email show in the UI elsewhere
        // (so admins fix them) but aren't valid `to` targets.
        return records
            .filter((s) => s.isActive && s.assignedEmail)
            .map((s) => ({
                email: s.assignedEmail,
                label: s.label,
                clientName: s.clientName,
            }));
    }, [slotsData]);
    const hasEmailAccess = accessibleEmails.length > 0;
    const accessibleEmailOptions = useMemo(
        () =>
            accessibleEmails.map((r) => ({
                value: r.email,
                label: r.label ? `${r.email} — ${r.clientName} (${r.label})` : `${r.email} — ${r.clientName}`,
                email: r.email,
                clientName: r.clientName,
            })),
        [accessibleEmails]
    );

    useEffect(() => {
        dispatch(fetchEmployeeClientsThunk(userid));
        dispatch(fetchEmployeesByRoute({ route: "/request" }));
    }, [dispatch, userid]);


    const getAssignToUsers = (usersList) => {

        const usersListFormatted = [];
        for (let i = 0; i < usersList?.length; i++) {
            usersListFormatted.push({
                key: i,
                value: usersList[i].firstname + " " + usersList[i].lastname,
            });
        }
        return usersListFormatted;
    }
    const initialValues = {
        id: RequestInfo?.id,
        requestId: RequestInfo?.requestId,
        priority: "On Demand",
        processType: "",
        assignedTo: loginUser?.firstname + " " + loginUser?.lastname,
        assignTo: "",
        requestStatus: "Open",
        Assign: true,
        fromPending: false,
        instructions: false,
        from: "",
        to: "",
        subject: "",
        body: "",
        date: "",
        client: "",
        clientName: "",
        quoteType: "",
        department: "",
        insuredName: "",
        noofQuotes: "",
        holderName: "",
        insuredDelivery: "",
        holderDelivery: "",
        accountManagerDelivery: "",
        otherDelivery: "",
        radioValue: "",
        Auto: "" || false,
        MotorCycle: "" || false,
        Boat: "" || false,
        DP3: "" || false,
        HO3: "" || false,
        HO4: "" || false,
        HO5: "" || false,
        HO6: "" || false,
        umbrella: "" || false,
        flud: "" || false,
        isOthers: "" || false,
        others: "",
        emailSummary: "",
        requestor: "",
        sendTo: "",
        newQuoteInformation: [{
            policy: "",
            insuranceCarrier: "",
            eligibility: "",
            quotedPremium: "",
            remarks: "",
        }],
        existingPolicyInformation: [{
            currentCarrier: "",
            propertyType: "",
            propertyNew: "",
            policyNumber: "",
            effectiveDate: null,
            currentPremium: ""
        }]
    }
    const priorityHandler = (values, setFieldValue) => {
        let priority = values.priority;
        const { body, subject } = values;
        if (!priority && (body?.toLowerCase().includes("urgent") || body?.toLowerCase().includes("rush") || subject?.toLowerCase().includes("urgent") || subject?.toLowerCase().includes("rush"))) {
            priority = 'Rush';
        }

        setFieldValue('priority', priority);
        return priority;
    };
    const cancelHandelar = () => {
        handleClose()
        dispatch(submitRefreshPage(false));
    };
    const handleDialogCancelClose = () => {
        setSetPopupStatus(false)
    }

    return (
        <>
            <Modal
                title="Submit Status"
                open={popupStatus}
                onCancel={handleDialogCancelClose}
                footer={[
                    <Button key="ok" type="primary" onClick={handleDialogClose}>OK</Button>
                ]}
            >
                <p>{submitStatus}</p>
            </Modal>

            <div style={{ width: '100%', marginBottom: "5px" }}>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={requestSubmit}
                >
                    {({ handleChange, handleSubmit, values, setFieldValue, errors, touched }) => (
                        <Form onFinish={handleSubmit} layout='vertical'>

                            <Row gutter={16} style={{ marginBottom: "10px" }}>
                                <Col span={24} style={{ marginTop: 16 }}>
                                    <Space>
                                        <AntdButton label="Submit" color='primary' variant='solid' htmlType="submit" disabled={isDisabled} />
                                        <AntdButton label="Close" color='danger' variant='solid' onClick={cancelHandelar} />
                                    </Space>
                                </Col>
                            </Row>

                            <Card
                                style={{ marginBottom: "5px" }}
                                title={
                                    <Typography.Title
                                        level={5}
                                        style={{ marginBottom: 0, textAlign: "left", fontWeight: "bold" }}
                                    >
                                        Add Request
                                    </Typography.Title>
                                }
                            >

                                <div className="add-request-grid">

                                    {/* LEFT PANEL */}
                                    <div className="ar-left-panel">

                                        {/* Un Assign (checkbox instead of switch) */}
                                        <div className="ar-row">
                                            <label>UnAssign</label>
                                            <Checkbox
                                                checked={values.Assign}
                                                onChange={(e) => {
                                                    const isChecked = e.target.checked;
                                                    if (isChecked) {
                                                        setFieldValue("requestStatus", "In Progress");
                                                        setFieldValue("assignedTo", loginUser?.firstname + " " + loginUser?.lastname);
                                                        setFieldValue("Assign", true);
                                                    } else {
                                                        setFieldValue("requestStatus", "Open");
                                                        setFieldValue("assignedTo", "");
                                                        setFieldValue("Assign", false);
                                                    }
                                                }}

                                            />
                                        </div>

                                        <div className="ar-row">
                                            <label>Assigned To</label>
                                            <InputField disabled value={values.assignedTo} />
                                        </div>

                                        <div className="ar-row" style={{ marginTop: '3px' }}>
                                            <label style={{ marginTop: '-20px' }}>Assign To</label>
                                            <SelectInput
                                                value={values.assignTo}
                                                showSearch
                                                options={getAssignToUsers(employeeOptions)}
                                                onChange={(v) => {
                                                    setFieldValue("assignTo", v);
                                                    setFieldValue("assignedTo", v);
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* RIGHT PANEL */}
                                    <div className="ar-right-panel">

                                        {/* COLUMN 1 */}
                                        <div className="ar-col">
                                            <div className="ar-row">
                                                <label style={{ marginTop: '-20px' }}>Process Type</label>
                                                <SelectInput
                                                    name="processType"
                                                    value={values.processType}
                                                    options={getOptionsByPath(NestedDatabucket, [CLIENT_INFO, CLIENT_SERVICESASSIGNED])}
                                                    onChange={(v) => setFieldValue("processType", v)}
                                                    placeholder="Enter Process Type"
                                                />
                                            </div>

                                            <div className="ar-row">
                                                <label style={{ marginTop: '-20px' }}>Priority</label>
                                                <SelectInput
                                                    name="priority"
                                                    value={values.priority}
                                                    options={getOptionsByPath(NestedDatabucket, [ADD_REQUEST, REQUEST_PRIORITY])}
                                                    onChange={(v) => setFieldValue("priority", v)}
                                                    placeholder="Enter Priority"
                                                />
                                            </div>
                                        </div>

                                        {/* COLUMN 2 */}
                                        <div className="ar-col">
                                            <div className="ar-row">
                                                {hasEmailAccess ? (
                                                    <>
                                                        <label style={{ marginTop: '-20px' }}>
                                                            Send to (Client Email){' '}
                                                            {touched.to && errors.to && <span style={{ color: '#ff4d4f', fontSize: 11 }}>({errors.to})</span>}
                                                        </label>
                                                        <SelectInput
                                                            name="to"
                                                            showSearch
                                                            value={values.to || undefined}
                                                            status={(touched.to && errors.to) || (touched.clientName && errors.clientName) ? 'error' : ''}
                                                            options={accessibleEmailOptions}
                                                            onChange={(v) => {
                                                                const picked = accessibleEmailOptions.find((o) => o.value === v);
                                                                setFieldValue('to', v || '');
                                                                setFieldValue('clientName', picked?.clientName || '');
                                                            }}
                                                            placeholder="Pick a client email"
                                                        />
                                                        {values.clientName ? (
                                                            <div style={{ fontSize: 11, color: '#8c8c8c', marginTop: 4 }}>
                                                                Client: <strong>{values.clientName}</strong>
                                                            </div>
                                                        ) : null}
                                                    </>
                                                ) : (
                                                    <>
                                                        <label style={{ marginTop: '-20px' }}>Client Name {touched.clientName && errors.clientName && <span style={{ color: '#ff4d4f', fontSize: 11 }}>({errors.clientName})</span>}</label>
                                                        <SelectInput
                                                            name="clientName"
                                                            showSearch
                                                            value={values.clientName}
                                                            status={touched.clientName && errors.clientName ? 'error' : ''}
                                                            options={clientsData.map(x => ({ value: x.NameOfClient, label: x.NameOfClient }))}
                                                            onChange={(v) => setFieldValue("clientName", v)}
                                                            placeholder="Select Client Name"
                                                        />
                                                    </>
                                                )}
                                            </div>

                                            <div className="ar-row">
                                                <label>Instructions</label>
                                                <Checkbox
                                                    checked={values.instructions}
                                                    onChange={(e) => setFieldValue("instructions", e.target.checked)}
                                                />
                                            </div>
                                        </div>

                                        {/* COLUMN 3 */}
                                        <div className="ar-col">
                                            <div className="ar-row">
                                                <label>Subject {touched.subject && errors.subject && <span style={{ color: '#ff4d4f', fontSize: 11 }}>({errors.subject})</span>}</label>
                                                <InputField
                                                    name="subject"
                                                    value={values.subject}
                                                    error={touched.subject && errors.subject}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        priorityHandler(
                                                            { ...values, subject: e.target.value },
                                                            setFieldValue
                                                        );
                                                    }}
                                                />

                                            </div>

                                            <div className="ar-row">
                                                <label>From {touched.from && errors.from && <span style={{ color: '#ff4d4f', fontSize: 11 }}>({errors.from})</span>}</label>
                                                <InputField
                                                    name="from"
                                                    type="email"
                                                    value={values.from}
                                                    error={touched.from && errors.from}
                                                    onChange={handleChange}
                                                    placeholder="Enter From Email"
                                                />
                                            </div>

                                            {hasEmailAccess ? (
                                                // To is set by the Send-to picker in column 2 — no separate input.
                                                null
                                            ) : (
                                                <div className="ar-row">
                                                    <label>To {touched.to && errors.to && <span style={{ color: '#ff4d4f', fontSize: 11 }}>({errors.to})</span>}</label>
                                                    <InputField
                                                        name="to"
                                                        type="email"
                                                        value={values.to}
                                                        error={touched.to && errors.to}
                                                        onChange={handleChange}
                                                        placeholder="Enter To Email"
                                                    />
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                </div>

                                {/* BODY */}
                                <div style={{ marginTop: "10px" }}>
                                    <label style={{ fontSize: 12, display: "block", }}>
                                        Body {touched.body && errors.body && <span style={{ color: '#ff4d4f', fontSize: 11 }}>({errors.body})</span>}
                                    </label>

                                    <TextareaField
                                        name="body"
                                        value={values.body}
                                        status={touched.body && errors.body ? 'error' : ''}
                                        onChange={(e) => {
                                            handleChange(e);
                                            priorityHandler(
                                                { ...values, body: e.target.value },
                                                setFieldValue
                                            );
                                        }}
                                    />

                                </div>

                            </Card>


                            <RequestForm
                                initialValues={initialValues}
                                employeeDetails={employeeDetails}
                                setEmployeeDetails={setEmployeeDetails}
                                handleChange={handleChange}
                                values={values}
                                errors={errors}
                                touched={touched}
                            />
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    );

}
export default AddRequest;